import { AccredibleBaseSelectInputComponent } from '@accredible-frontend-v2/components/base-components/base-select-input';
import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { Component } from '@angular/core';

let nextUniqueId = 0;

@Component({
  selector: 'accredible-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  // We are not using ChangeDetectionStrategy.OnPush because this input component
  // does not detect changes when formGroup.markAllAsTouched() is triggered
})
export class AccredibleSearchInputComponent extends AccredibleBaseSelectInputComponent {
  searchInputLabelId = `accredible-search-input-${nextUniqueId++}`;

  selectOption(event: Event, option: AccredibleObjectWithId): void {
    event && event.stopPropagation();
    this.formControlRef.setValue(option);
    this.select.emit(option);

    this.inputBlurred();
    this._filterOptions();
  }

  clearSelected(): void {
    this.formControlRef.setValue(null);
    this.clear.emit();
  }

  protected _hideSelectedOptions(
    availableOptions: AccredibleObjectWithId[],
  ): AccredibleObjectWithId[] {
    return !this.dynamic && this.formControlRef?.value
      ? availableOptions.filter((option) => option.id !== this.formControlRef.value.id)
      : availableOptions;
  }
}
